export const getSession = () => JSON.parse(localStorage.getItem("session"));
